import { Outlet, RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths, ROUTE_SEGMENTS } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.projects.root,
    element: loadable(() => import('./pages/ProjectsPage')),
    children: [
      {
        path: paths.projects.children.details,
        element: loadable(() => import('./pages/ProjectDetails')),
        children: [
          { path: ROUTE_SEGMENTS.edit, element: <Outlet /> },
          { path: ROUTE_SEGMENTS.clone, element: <Outlet /> },
          {
            path: ROUTE_SEGMENTS.tickets.root,
            element: <Outlet />,
            children: [
              { path: ROUTE_SEGMENTS.new, element: <Outlet /> },
              {
                path: ROUTE_SEGMENTS.tickets.details,
                element: <Outlet />,
                children: [
                  { path: ROUTE_SEGMENTS.edit, element: <Outlet /> },
                  {
                    path: ROUTE_SEGMENTS.tickets.comments,
                    element: <Outlet />,
                  },
                  {
                    path: ROUTE_SEGMENTS.tickets.commentsNew,
                    element: <Outlet />,
                  },
                  {
                    path: ROUTE_SEGMENTS.tickets.relatedTasks,
                    element: <Outlet />,
                  },
                  {
                    path: ROUTE_SEGMENTS.tickets.relatedTasksNew,
                    element: <Outlet />,
                  },
                  {
                    path: ROUTE_SEGMENTS.tickets.activityLog,
                    element: <Outlet />,
                  },
                ],
              },
            ],
          },
          {
            path: ROUTE_SEGMENTS.tasks.root,
            element: <Outlet />,
            children: [
              { path: ROUTE_SEGMENTS.new, element: <Outlet /> },
              {
                path: ROUTE_SEGMENTS.tasks.details,
                element: <Outlet />,
                children: [
                  { path: ROUTE_SEGMENTS.edit, element: <Outlet /> },
                  { path: ROUTE_SEGMENTS.tasks.subtasks, element: <Outlet /> },
                  {
                    path: ROUTE_SEGMENTS.tasks.subtasksNew,
                    element: <Outlet />,
                  },
                  {
                    path: ROUTE_SEGMENTS.tasks.subtasksEdit,
                    element: <Outlet />,
                  },
                  { path: ROUTE_SEGMENTS.tasks.comments, element: <Outlet /> },
                  {
                    path: ROUTE_SEGMENTS.tasks.commentsNew,
                    element: <Outlet />,
                  },
                  {
                    path: ROUTE_SEGMENTS.tasks.activityLog,
                    element: <Outlet />,
                  },
                ],
              },
            ],
          },
          {
            path: paths.projects.details.tab,
            element: <Outlet />,
            children: [{ path: ROUTE_SEGMENTS.add, element: <Outlet /> }],
          },
        ],
      },
    ],
  },
];
